import { useState } from "react";
import { Link } from "react-router-dom";
import CardOptionsMenu from "./CardOptionsMenu";

const ParagraphCard = ({
    id,
    optionsEnabled = true,
    title = "Без названия",
    description = "",
    link = "#",
    themes = [],
    onDelete,
    onEdit,
}) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const handleDelete = () => {
        if (!id) {
            console.error("Ошибка: id параграфа не передан! Значение id:", id);
            return;
        }

        if (!window.confirm("Вы уверены, что хотите удалить этот параграф?")) return;

        onDelete(id);
    };

    return (
        <div className="relative shrink-0 basis-[278px] bg-lavender-8 rounded-2xl p-2">
            {optionsEnabled && (
                <div className="absolute top-2 right-2 z-10">
                    <CardOptionsMenu
                        onEdit={() => onEdit({ id, title, description, themes })}
                        onDelete={handleDelete}
                        onToggle={() => setIsMenuOpen(!isMenuOpen)}
                    />
                </div>
            )}
            <Link to={link} className="block min-h-[205px]" onClick={() => setIsMenuOpen(false)}>
                <div className="relative w-full min-h-[123px] bg-lavender rounded-xl flex items-end p-2 gap-1">
                    {themes.length > 0 && (
                        <span className="absolute top-2 left-2 bg-white text-lavender-700 px-3 py-1 rounded-full text-xs font-semibold shadow">
                            {themes.length} темы
                        </span>
                    )}
                </div>
                <div className="py-4 px-2 leading-5">
                    <h4 className="font-semibold">{title}</h4>
                    <p className="opacity-50">{description || ""}</p>
                </div>
            </Link>
        </div>
    );
};

export default ParagraphCard;
